import * as React from 'react';
import styled from '@emotion/styled';

export const CUSTOMER_LOGOS = [
  { name: 'Aviat Networks', logo: require('../../../media/customer-logos/aviat-networks-logo-grey.png') },
  { name: 'Emerson', logo: require('../../../media/customer-logos/emerson-logo-grey.png') },
  { name: 'Sandvik', logo: require('../../../media/customer-logos/sandvik-logo-grey.png') },
  { name: 'NOV', logo: require('../../../media/customer-logos/nov-logo-grey.png') },
  { name: 'Halliburton', logo: require('../../../media/customer-logos/halliburton-logo-grey.png') }
];

export const CustomerLogos: React.FC = () => (
  <Logos>
    {CUSTOMER_LOGOS.map((customer) => (
      <img key={customer.name} src={customer.logo} alt={customer.name} />
    ))}
  </Logos>
);

const Logos = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  img {
    filter: ${(p) => (p.theme.light ? 'brightness(0)' : 'brightness(100)')};
    opacity: 0.5;
  }
`;
